import script from "./AddUserFieldGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserFieldGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddUserFieldGroup.vue?vue&type=style&index=0&id=5a5cafd0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5cafd0"]])

export default __exports__